import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class AlertLevelsService {

  static listAll() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}alertlevels`).then((data) => {
        resolve({ alertLevels: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

}

export default AlertLevelsService;
